import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

// Material UI
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

// Phone Input
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'

// Styles
import { makeStyles } from '@material-ui/core/styles'

// Translation
import { Language } from '../../Translation'

// Redux
import { connect } from 'react-redux'
import { addClient } from '../../redux/actions/clientActions'

const useStyles = makeStyles((theme) => ({
    media: {
        height: '100%',
        maxHeight: 300,
        paddingTop: 5,
        paddingBottom: 5,
    },
    footer: {
        backgroundColor: "#f5f5f5",
        width: "100%",
        bottom: 0,
        zIndex: 1000,
    },
    name: {
        top: 20,
        marginBottom: 40,
    },
    pickup: {
        top: 20,
        marginBottom: 40,
    },
    box: {
        textAlign: "center",
        marginBottom: 70,
    },
    continueButton: {
        width: "100%",
        backgroundColor: "#003366",
    },
    errorPhone: {
        color: "#f44336",
        marginLeft: 14,
        marginRight: 14,
        marginTop: 3,
        fontSize: "0.75rem",
        lineHeight: 1.66,
        letterSpacing: "0.03333em",
    },
}));

const DiningPickup = ({ clientData, addClient }) => {

    const [client, setClient] = useState({
        UID: 0,
        name: "",
        phone: "",
        email: "",
        address: "",
        apt: "",
        city: "",
        zipCode: "",
        notes: "",
        pickup: "",
        diningOption: "Price_Pickup",
        diningView: "Pickup_View",
    })

    const { language } = clientData
    const [nameError, setNameError] = useState(false)
    const [nameErrorText, setNameErrorText] = useState("")
    const [phoneError, setPhoneError] = useState(true)

    const classes = useStyles()
    const history = useHistory()

    const clientSubmit = () => {

        if (handleValidation()) {

            // Add client info to redux
            addClient(client)

            // Go to menu
            history.push("menu")
        }

    }

    const handleValidation = () => {

        let infoIsValid = true

        if (!client.name) {
            infoIsValid = false
            setNameError(true)
        } else {
            setNameError(false)
        }

        if (client.phone === "") {
            infoIsValid = false
            setPhoneError(false)
            setNameErrorText(Language.DiningPhoneError[language])
        }
        else if (client.phone.length < 10) {
            infoIsValid = false
            setPhoneError(false)
            setNameErrorText(Language.DiningPhoneErrorLength[language])
        } else {
            setPhoneError(true)
        }

        return infoIsValid

    }

    return (

        <>
            <Box p={1}>
                <TextField
                    id="name"
                    label={Language.DiningName[language]}
                    className={classes.name}
                    multiline
                    fullWidth
                    rowsMax={4}
                    value={client.Name}
                    onChange={event => {
                        const { value } = event.target;
                        setClient({ ...client, name: value })
                    }}
                    variant="outlined"
                    error={nameError}
                    helperText={nameError === true ? Language.DiningNameError[language] : ''}
                />

                <PhoneInput
                    country={'ca'}
                    onlyCountries={['ca']}
                    value={client.Phone}
                    onChange={phone => setClient({ ...client, phone: phone })}
                    disableDropdown={true}
                    placeholder={'XXX-XXX-XXXX'}
                    inputStyle={{ width: '100%' }}
                    disableCountryCode={true}
                    isValid={phoneError}
                />
                {!phoneError && <p className={classes.errorPhone}>{nameErrorText}</p>}

                <TextField
                    id="pickup"
                    label={Language.DiningPickupTime[language]}
                    className={classes.pickup}
                    multiline
                    fullWidth
                    rowsMax={4}
                    value={client.Pickup}
                    onChange={event => {
                        const { value } = event.target;
                        setClient({ ...client, pickup: value })
                    }}
                    variant="outlined"
                />
            </Box>

            <Card className={classes.footer}>
                <CardContent>
                    <Button onClick={() => clientSubmit()} className={classes.continueButton} variant="contained" size="large">
                        <Typography style={{ color: "white" }}>{Language.DiningContinue[language]}</Typography>
                    </Button>
                </CardContent>
            </Card>
        </>

    )
}

const mapDispatchToProps = dispatch => {
    return {
        addClient: (clientInfo) => dispatch(addClient(clientInfo))
    }
}

const mapStateToProps = state => {
    return {
        clientData: state.clientData
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DiningPickup)